import { ClipLoader } from "react-spinners";

import { useGetSocials, useUpdateSocials } from "../../apis";
import { SocialsForm } from "../../components";
import { SocialsData } from "../../content.types";

import styles from "./Socials.module.scss";

const SOCIALS_FORM_ID = "socials-form-id";

const Socials = () => {
  const { socialsData, isLoading } = useGetSocials();

  const updateSocials = useUpdateSocials();

  const handleFormSubmit = (formData: SocialsData) => {
    updateSocials.mutate(formData);
  };

  return (
    <div className={styles.socials}>
      {!isLoading && socialsData ? (
        <SocialsForm
          formId={SOCIALS_FORM_ID}
          onSubmit={handleFormSubmit}
          defaultValues={socialsData}
          isLoadingUpdate={updateSocials.isLoading}
        />
      ) : (
        <div className={styles.socials_loader}>
          <ClipLoader size={50} color="#fb3973" />
        </div>
      )}
    </div>
  );
};

export default Socials;
